import { formatMagnitude } from '@dawn/core/utils';
import { IdentityAccessBody } from '@dawn/ui';

import type { WidgetConfig } from '@/config/dashboard.types';

import { WidgetShell } from '../WidgetShell';

/**
 * Inline mirror of the dashboard API's `NonHumanIdentitiesResponse`. Kept
 * local per design §5 #11 — no shared contract package for V2.
 */
interface NonHumanIdentitiesResponseData {
  total: number;
  change: number;
  changeDirection: 'positive' | 'negative' | 'neutral';
  activeCount: number;
  activePercent: number;
  nonActiveCount: number;
  nonActivePercent: number;
}

function narrowNonHumanIdentitiesData(input: unknown): NonHumanIdentitiesResponseData | null {
  if (input === null || typeof input !== 'object') return null;
  const candidate = input as Record<string, unknown>;
  if (typeof candidate.total !== 'number') return null;
  return candidate as unknown as NonHumanIdentitiesResponseData;
}

export function NonHumanIdentitiesWidget({ config }: { config: WidgetConfig }) {
  return (
    <WidgetShell
      config={config}
      renderData={(envelopeData) => {
        const data = narrowNonHumanIdentitiesData(envelopeData);
        if (!data) return null;
        return (
          <IdentityAccessBody
            total={data.total}
            change={data.change}
            changeDirection={data.changeDirection}
            activeCount={data.activeCount}
            activePercent={data.activePercent}
            nonActiveCount={data.nonActiveCount}
            nonActivePercent={data.nonActivePercent}
            // The relation has no NHI type dimension, so the payload's
            // breakdown is always empty and the popover never opens.
            breakdown={[]}
            caption="Non Human Identities"
            popoverTitle="Total NHI"
            popoverCategory="Identities"
            donutCenterLabel="Active"
            activeLegendLabel="Active"
            nonActiveLegendLabel="Non-active"
            formatNumber={formatMagnitude}
          />
        );
      }}
    />
  );
}
